<template>
  <div class="tw-text-xs tw-text-right">
    <span class="tw-text-green-500"> +X%: Aumenta en X puntos % </span>
    <legend-separator></legend-separator>
    <span class="tw-text-red-500"> -X%: Disminuye en X puntos % </span>
    <legend-separator></legend-separator>
    <span class="tw-text-gray-500"> +0%: Valor igual al período anterior </span>
    <legend-separator></legend-separator>
    <span class="tw-text-gray-500">
      ?: No hay valor con el comparar con el período anterior
    </span>
  </div>
</template>

<script>
import LegendSeparator from "./LegendSeparator.vue";

export default {
  name: "PeriodComparatorLegend",
  components: {
    LegendSeparator,
  },
};
</script>
